<section class="mt-section">
  <div v-if="hasResults()">
    <fou-group bottom="medium">
      <v-grid in="10">
        <v-row>
          <v-col>
            <label
              :for="$vId(this, 'family-name')"
              class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20"
            >
              {{$t('pages.submissions.components.upload.results.font_family')}}
            </label>
            <p
              v-tooltip="{content: $t('pages.submissions.components.upload.results.custom_family_name'), placement: 'right'}"
              :class="$style.quesCustom"
            >
              ?
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col :has="{'default': 5, 'xs': 10, 's': 10}">
            <fou-group v-if="someResultComplete()">
              <TextField
                name="family name upload"
                label="family name"
                type="text"
                :id="$vId(this, 'family-name')"
                v-model="family.name"
                :placeholder="$t('pages.submissions.components.upload.results.enter_family_name')"
                :input-class="[{'mt-input--error': Object.hasOwn(errors, 'family name upload')},'mt-input--block mt-serif--displayBold mt-serif--size1']"
                :blur="updateFamilyName"
                :moduleName="this.$route.name"
                :foundryId="this.submission.foundry?.foundryId"
                :description="family.name"
                @update-banned-word="bannedWordforFamilyName= $event"
                :focus="familyNameFocus"
                :rules="`min:3|alpha_num_space_ampersand:${hasRole(['foundrySupport'])}|caps_alpha_first:${hasRole(['foundrySupport'])}|required|max:255|script_tag_validate`"
              />
            </fou-group>
            <fou-group> </fou-group>
            <div v-if="!someResultComplete()" :class="$style.loading">
              <load-animation></load-animation>
            </div>
          </v-col>
          <v-col has="5">
            <fou-group :class="$style.mTN23" v-if="someResultComplete()">
              <externalsku v-if="submissionPackages.length > 0" :id="$vId(this)" familyPackSku />
            </fou-group>
            <div v-if="!someResultComplete()" :class="$style.loading">
              <load-animation></load-animation>
            </div>
          </v-col>
        </v-row>
        <div class="row mt-group--bottom-medium">
          <v-col v-if="someResultComplete()" has="10">
            <fou-group v-if="!hasRole(['foundrySupport']) && submission.status === 'in_work'">
              <vee-field
              name="Check your font name upload"
              label="commitment box"
              rules="required|check_foundry_agreements"
              v-slot="{field, errorMessage}"
              v-model="chk1"
            >
              <div :class="[$style.commitmentBox, {[$style.errorCommitmentBox]: !(check1 && check2 && check3 && check4) && errorMessage}]">
                <div :class="[$style.step2Box]">
                  <p class="mt-serif--bold mt-serif--bold--size3 mb-15"
                    v-html="$t('components.navigation.sign_up.step_2.checkbox_container.heading')">
                  </p>
                  <p :class="[$style.boxDesc]"
                    v-html="$t('components.navigation.sign_up.step_2.checkbox_container.heading_desc')">
                  </p>
                  <div class="mt-20" :class="[$style.customRow]">
                    <div class="mr-20">
                      <input
                        :class="[$style.step2Checkbox]"
                        type="checkbox"
                        data-vv-validate-on="change"
                        v-validate="'required'"
                        name="commitment_box" v-model="check1" />
                    </div>
                    <div v-html="$t('components.navigation.sign_up.step_2.checkbox_container.cbox_1')">
                    </div>
                  </div>
                  <div class="mt-20" :class="[$style.customRow]">
                    <div class="mr-20">
                      <input
                        :class="[$style.step2Checkbox]"
                        type="checkbox"
                        data-vv-validate-on="change"
                        v-validate="'required'"
                        name="commitment_box" v-model="check2" />
                    </div>
                    <div v-html="$t('components.navigation.sign_up.step_2.checkbox_container.cbox_2')">
                    </div>
                  </div>
                  <div class="mt-20" :class="[$style.customRow]">
                    <div class="mr-20">
                      <input
                        :class="[$style.step2Checkbox]"
                        type="checkbox"
                        data-vv-validate-on="change"
                        v-validate="'required'"
                        name="commitment_box" v-model="check3" />
                    </div>
                    <div v-html="$t('components.navigation.sign_up.step_2.checkbox_container.cbox_3')">
                    </div>
                  </div>
                  <div class="mt-20" :class="[$style.customRow]">
                    <div class="mr-20">
                      <input
                        :class="[$style.step2Checkbox]"
                        type="checkbox"
                        data-vv-validate-on="change"
                        name="commitment_box" v-model="check4"
                        v-validate="'required'" />
                    </div>
                    <div v-html="$t('components.navigation.sign_up.step_2.checkbox_container.cbox_4')">
                    </div>
                  </div>
                </div>
              </div>
              <p v-if="!(check1 && check2 && check3 && check4) && errorMessage" class="ml-0 mt-error">You must check all boxes to proceed. Please read all information carefully</p>
            </vee-field>
            </fou-group>
          </v-col>
        </div>
        <smart-sorting :getSmartSortTrigger="sortFonts" :result=true v-if="results.items.length > 1"></smart-sorting>
        <v-row v-if="hasRole(['foundrySupport'])">
          <div class="mt-serif mt-serif--size5" :class="[$style.lowerCase, $style.custMargin]">
            {{fontURI}}{{foundryRootDir}}/
          </div>
          <div :class="[$style.marTop15]">
            <TextField
              name="unique_name upload"
              label="unique_name"
              type="text"
              :id="$vId(this, 'unique-name')"
              v-model="family.uniqueName"
              :show-error-message="false"
              :disabled="getLiveParam(submission)"
              :input-class="[$style.lowerCase, {'mt-input--error': stepsHasErrorsUrl}, {[$style.disabled] : getLiveParam(submission)},'mt-input--block mt-serif mt-serif--size4']"
              :key-up="($event)=> {checkUniqueURL();setFontFamilyURL($event)}"
              :blur="($event)=> {checkUniqueURL();setFontFamilyURL($event)}"
              rules="required|script_tag_validate|max:50"
            />
            <fou-group v-if="stepsHasErrorsUrl">
              <p class="mt-error" :class="$style.mTop5">{{$t('pages.submissions.review.errorUrlUniqueMessage')}}</p>
            </fou-group>
          </div>
        </v-row>
      </v-grid>
    </fou-group>
    
    <fou-group v-if="getScanStatus === ''">
      <span :class="$style.searchingMalware"></span>
      <span :class="$style.malwareText"> {{$t('malwareScan.scanInitiationMessage')}} </span>
    </fou-group>

    <fou-group v-if="getScanStatus === true">
      <span :class="$style.successMalwareIcon"></span>
      <span :class="$style.malwareText"> {{$t('malwareScan.scanCompletionMessage')}} </span>
    </fou-group>

    <fou-group v-else-if="getScanStatus === false">
      <span :class="$style.malwareIcon"></span>
      <span :class="$style.malwareText"> {{$t('malwareScan.malwareDetectionMessage')}} </span>
    </fou-group>
    
    <fou-group bottom="medium">
      <v-grid in="10">
        <v-row :class="$style.resultHeader">
          <v-col has="6" off="1">
            <div :class="[$style.name, 'out-left']">
              <span class="mt-label mt-label--black mt-label--none mt-label--size12">
                {{$tc('pages.submissions.components.upload.results.click_style_name', results.items.length, { count:
                  results.items.length })}}
              </span>
            </div>
          </v-col>
          <v-col has="2">
            <span :class="$style.ltrSpacing" class="mt-label mt-label--black mt-label--capitalise mt-label--size12">
              {{$t('pages.submissions.components.upload.results.fontfile')}}
            </span>
          </v-col>
          <div :class="$style.mL10" class="mt-flex mt-flex--end">
            <span class="mt-label mt-label--black mt-label--capitalise mt-label--size12"
              >{{$t('pages.submissions.components.upload.results.fonttest')}}</span
            >
          </div>
        </v-row>
        <draggable
          :id="$vId(this)"
          element="ul"
          :list="results.items"
          :options="{'disabled': isDragDropDisable}"
          :class="$style.resultList"
          class="mt-group"
          item-key="id"
          filter=".drag-disabled"
          :preventOnFilter="false"
          @start="draggableStart"
          @end="draggableEnd; unsetSmartSort()"
        >
          <template #item="{element, index}">
            <v-grid
              in="10"
              element="li"
              :class="[$style.resultItem,{[$style.bgColorBlue]: (element?.status === `new` || element?.status === `updated`)}]"
              :key="index"
            >
              <v-row :class="$style.result">
                <v-col has="1" class="mt-flex">
                  <div :class="$style.sorting">
                    <span class="item" :class="$style.dragndrop"></span>
                  </div>
                </v-col>
                <v-col has="6">
                  <div
                    :class="$style.name"
                    class="out-left"
                    v-tooltip="{content: element.fileName, placement: 'bottom'}"
                  >
                    <fou-picture
                      v-if="isResultComplete(element)"
                      :id="$vId(this, 'render-' + element.id)"
                      :src="getBinaryFontRenderSrc(element.id, (getFormattedDefaultStyleName(element)), 30)"
                      :alt="family.name"
                    />
                    <span v-if="!isResultComplete(element)" :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </div>

                  <div class="mt-flex mt-flex--start mt-15">
                    <div class="out-left" :class="[$style.newWidth, $style.posRelative]">
                      <span class="mt-label mt-label--capitalise">
                        {{$t('pages.submissions.components.upload.results.style_name')}}
                      </span>
                      <p
                        v-if="isResultComplete(element)"
                        @mouseleave="mouseleave($event)"
                        v-tooltip="{content: family.name, placement: 'bottom'}"
                        :class="$style.familyPosition"

                      >
                        {{family.name}}
                      </p>
                      <div class="drag-disabled">
                        <StyleTextBox
                        v-if="isResultComplete(element)"
                        :key="`style-${element.id}-${family.name || 'default'}`"
                        :id="$vId(this, 'style-name-' + (element.id))"
                        :name="`style name ${element.id} upload`"
                        :label="`style name ${index+1}`"
                        :default-value="getFormattedDefaultStyleName(element)"
                        :model-value="{id: element.id, name: getFormattedDefaultStyleName(element)}"
                        @blur="(event) => updateSubmissionOnStyleNameBlur(event, element)"
                        :placeholder="$t('pages.submissions.components.upload.results.unknown')"
                        :rules="`caps_alpha_first:${hasRole(['foundrySupport'])}|script_tag_validate|required|lengthChar:80|uniqueStyle: ${getStyleNames()}`"
                        :input-class="['mt-input','mt-serif','mt-serif--size4',
                                      $style.metaField, $style.padLeft,
                                      {'mt-input--error': Object.hasOwn(errors,`style name ${element.id} upload`)}]"
                        :error-class="[$style.errorField]"
                        :moduleNameValue="this.$route.name"
                        :foundryIdValue="this.submission.foundry?.foundryId"
                        @banned-word-exist="bannedWordForStyleName"
                        @mouseover="handleMouseOver"
                        @mouseout="handleMouseOut"
                        >
                      </StyleTextBox>
                      <span
                        v-else
                        :class="$style.loading">
                        <load-animation></load-animation>
                      </span>
                      </div>
                    </div>
                    <externalsku
                      v-if="isResultComplete(element) && submissionPackages.length > 0"
                      :id="$vId(this, `externalsku${element.id}`)"
                      :index="index"
                      :element-id="element.id"
                      single-pack-sku
                      :mouse-over-handler="handleMouseOver"
                      :mouse-out-handler="handleMouseOut"
                    />
                  </div>
                </v-col>
                <v-col has="2">
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]"> {{$t('pages.submissions.components.upload.results.format')}} </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.format}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">
                      {{$t('pages.submissions.components.upload.results.weight_class')}}
                    </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.weightClass}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">
                      {{$t('pages.submissions.components.upload.results.width_class')}}
                    </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.widthClass}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]"> {{$t('pages.submissions.components.upload.results.style')}} </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.isItalic ? 'italic': 'non-italic'}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase, $style.versionRow]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">{{ $t('pages.submissions.components.upload.results.version') }}</span>
                    <span v-if="!getBinaryVersionText(element)" :class="[$style.mL5]">
                      {{ $t('pages.submissions.components.upload.results.version_not_found') }}
                    </span>
                    <span
                      v-else-if="getBinaryVersionTooltip(element)"
                      :class="[$style.mL5]"
                      v-tooltip="getBinaryVersionTooltip(element)"
                    >{{ getBinaryVersionDisplay(element) }}</span>
                    <span v-else :class="[$style.mL5]">{{ getBinaryVersionText(element) }}</span>
                  </p>
                  <p>
                    <button
                      v-if="hasRole(['foundrySupport']) || (!hasRole(['foundrySupport']) && !submission.isLive)"
                      class="mt-link"
                      @click="removeResult(index)"
                    >
                      <trash-icon></trash-icon>
                    </button>
                  </p>
                </v-col>
                <v-col has="1">
                  <div v-if="isResultComplete(element)">
                    <binary-validation-icons
                      :index="element.id"
                      :result="element"
                      :is-complete="showBinaryValidationProgress(element)"
                    >
                    </binary-validation-icons>
                  </div>
                  <span v-else :class="[$style.loading, $style.resultStatusIcon]">
                    <load-animation></load-animation>
                  </span>
                </v-col>
              </v-row>
              <v-row v-if="hasRole(['foundrySupport']) && !submission.isLive">
                <div class="mt-serif mt-serif--size5" :class="[$style.fontStyleUrlView, $style.lowerCase]">
                  {{fontURI}}{{foundryRootDir}}/{{normalizeDiacriticsOnString(family.uniqueName)}}/{{dashedString(element.styleName)}}
                </div>
              </v-row>
              <v-row v-if="hasRole(['foundrySupport']) && submission.isLive">
                <div class="mt-serif mt-serif--size5" :class="[$style.fontStyleUrlView, $style.lowerCase]">
                  {{fontURI}}{{foundryRootDir}}/{{normalizeDiacriticsOnString(family.uniqueName)}}/{{submissionBinaries[element.id].uniqueName
                  || dashedString(element.styleName)}}
                </div>
              </v-row>
            </v-grid>
          </template>
        </draggable>
        <div>
          <p class="mt-error" v-for="error in styleNameErrors">{{error}}</p>
        </div>
      </v-grid>
      <div v-if="results?.items[0]?.format && results.items.length === 1 && results.items[0].format !== 'OT TTFV'" :class="$style.singleStyleFontWarning">
        <MdTypography variant="body1--bold">
          {{$t('pages.submissions.index.single_style_warning_heading')}}
        </MdTypography>
        <MdTypography variant="body1--regular">
          {{$t('pages.submissions.index.single_style_warning_description')}}
        </MdTypography>
      </div>
    </fou-group>

    <fou-group bottom="medium" v-if="(submission.status === 'in_work' || submission.status === 'live')">
      <fou-group>
        <h3 class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20">
          {{$t('pages.submissions.components.upload.results.validator.title')}}
        </h3>
      </fou-group>
      <fou-group>
        <validator :id="$vId(this, 'results')" optimist @error-on-font="(v)=> {isErrorOnFont=v}" />
      </fou-group>
      <fou-group>
        <fou-modal :id="$vId(this, 'show-font-validation-results')" cols="10">
          <template #trigger>
            <button type="button" class="mt-link">
              {{$t('pages.submissions.components.upload.results.validator.show_overlay')}}
            </button>
          </template>
          <template #content>
            <fou-container :id="$vId(this, 'myfonts-display')" cols="10" boundless>
              <template #header>
                <p class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size30">
                  {{$t('pages.submissions.components.upload.results.validator.overlay.title')}}
                </p>
              </template>
              <template #content>
                <v-grid in="10" :class="$style.overlayInner">
                  <v-row>
                    <v-col has="8" off="1">
                      <fou-group class="out-left out-right">
                        <p
                          v-html="$sanitize($t('pages.submissions.components.upload.results.validator.overlay.description'))"
                        ></p>
                      </fou-group>
                      <fou-group bottom="medium" class="out-left out-right">
                        <validator :id="$vId(this, 'overlay')" />
                      </fou-group>
                    </v-col>
                  </v-row>
                </v-grid>
              </template>
            </fou-container>
          </template>
        </fou-modal>
      </fou-group>
    </fou-group>
    <customerMessage
      :id="$vId(this)"
      :as="$t('pages.submissions.components.customerMessage.textarea.name')"
      :rules="validateCustomerMsg"
      :fontResults="results"
      :errors="errors"
    />
  </div>

  <!-- //Popup start for custom package alert -->
  <fou-modal :id="$vId(this, 'customPackagePopupModal')" v-if="getCustomPackageModal" :visible="getCustomPackageModal" cols="6" :class="$style.popUpContainer">
    <template #content>
      <div>
        <p :class="$style.warnM">
          {{ $t('pages.submissions.components.upload.results.customPackageModal.title', {countDeletePackage: getValidCustomPackageLength}) }}</p>
        <p :class="$style.customPackageWarnDesc">{{
            $t('pages.submissions.components.upload.results.customPackageModal.desc', {
              countDeletePackage: getValidCustomPackageLength,
              allowedCustomPackageLength: getAllowedCustomPackageLength,
              countFontFiles: getCountFontFiles
            })
          }}</p>
        <div class="row">
          <button type="button" id="save" ref="save_btn" :class="$style.gotItBtn" @click="closeCustomPackagePopupModal">Got
            it!
          </button>
        </div>
      </div>
    </template>
  </fou-modal>
  <!-- Popup end -->
</section>
